import React from 'react'


/**
 * This function matches a device with a set of non-conformities by checking if the device
 * is included in the non-conformity's devices and if the device's fields match the
 * non-conformity's deviceProperties.
 * @param {Object} device - The device to match
 * @param {Array} nonConformities - The non-conformities to match against
 * @param {Object} template - The template to match against
 * @returns {Array} - An array of matching non-conformities
 */
export const matchNonConformities = (device, nonConformities = [], template) => {
    

    const templateNonConformities = !Array.isArray(nonConformities) ? [] : nonConformities?.filter?.((x)=>Array.isArray(x?.registers) && x?.registers?.some?.(y=>y?._ref == template?._id))
    const matchingNonComformities = !Array.isArray(templateNonConformities) ? [] : templateNonConformities?.filter?.((nonConformity) => {
        
        const devices = nonConformity?.devices
        const deviceProperties = nonConformity?.deviceProperties

        const templateDeviceMatch = devices
            ?.some?.((x)=>x?._ref == device?.templateDevice?._ref)
        
        const propertiesMatch = deviceProperties
            ?.some?.((nonConfProperty)=> device?.fields
                .some?.((field)=> field?.values
                    .some?.((value)=>value?._id == nonConfProperty?._ref))) 

        const devicesIncluded = () =>{
            if(nonConformity?.devicesExclude) return !templateDeviceMatch
            return templateDeviceMatch
        }
        const propertiesIncluded = () => {
            if(nonConformity?.propertiesExclude) return !propertiesMatch
            return propertiesMatch
        }
            
        //console.log("woooow",nonConformity.label, propertiesIncluded(), devicesIncluded() ) 

        if ((!devices || devices?.length==0) && (!deviceProperties || deviceProperties?.length==0)) return true
        if (propertiesIncluded() && devicesIncluded()) return true
        if (devicesIncluded() && (!deviceProperties || deviceProperties?.length==0) ) return true
        if ((!devices || devices?.length==0) && propertiesIncluded()) return true
       
        /*
        const fieldSetMatch = nonConformity?.fieldSets?.find?.(fieldSet => {
            const fieldKeys = Object.keys(fieldSet) // ['dimension', 'attachement']
            const everyKey = fieldKeys.every?.(fieldKey => {
                const setValue = fieldSet[fieldKey]
                const deviceField = device.fields?.find?.(field => {
                    const labelMatch = field.templateField.label === fieldKey
                    return labelMatch
                })
                const valueMatch = setValue === deviceField?.value
                return valueMatch
            })
            return everyKey
        })
        if (fieldSetMatch) return true

     */
        return false 
    })
    return matchingNonComformities
}

/* const ncMatches = matchNonConformities() */
/* const dimensionMatches = ncMatches?.filter?.(nc => nc?.fieldSets?.find?.(fieldSet => {
    return fieldSet?.dimension === 'DN70'
})) */

/**
 * Finds all non-conformities associated with a device
 * Iterates over an array of non-conformities and checks if each one matches the device's fields
 * If a non-conformity matches, it is added to the nonConformityArray
 * 
 * @param {Object} device - The device object
 * @param {Array} nonConformities - The array of non-conformities to check against
 * @returns {Array} - The array of matching non-conformities
 */
export const findNonConformities = (device, nonConformities = []) => {
    let nonConformityArray = []
    const deviceProperties = device.fields

    for (let i = 0; i < nonConformities.length; i++) {

        let nonConformity = nonConformities[i]
        let fields = nonConformities[i].fields
       
        for (let j = 0; j < fields.length; j++) {
            //console.log(fields[j])
            if (fields[j].length > 0) {
                if (fields[j].every?.(x => (deviceProperties.some?.(e => e._id === x._id)))) {
                    //console.log("non conformity:",nonConformity)
                    nonConformityArray = [...nonConformityArray,nonConformity]
                    //console.log("NC LIST:", nonConformityArray)
                }

            }
        
        }
    }

 return nonConformityArray

}
/**
 * 
 * @param {*} data {customersProducts, registerTemplate, device}
 * matches customer products with the device template and properties
 * @returns boolean
 */
export const matchCustomerProducts = (data) => {
    
    const {device, registerTemplate, deviceNonConformity, customerProducts = []} = data
   // const device = deviceNonConformity?.device
    const templateCustomerProducts = customerProducts.filter?.((x)=>{
        //if(x?.registers?.length < 1) return x
        //if(!x?.registers) return x
        return x?.registers?.some?.(y=>y?._ref == registerTemplate?._id)
    })

    const matchingCustomersProducts = templateCustomerProducts.filter?.((customerProduct) => {
      
        const devices = customerProduct?.devices
        const deviceProperties = customerProduct?.deviceProperties

        const templateDeviceMatch = devices
            ?.some?.((x)=>x._ref == device?.templateDevice?._ref)
        
        const propertiesMatch = deviceProperties
            ?.some?.((nonConfProperty)=> device?.fields
                ?.some?.((field)=> field?.values
                    ?.some?.((value)=>value?._id == nonConfProperty?._ref))) 

        const devicesIncluded = () =>{
            if(customerProduct.devicesExclude) return !templateDeviceMatch
            return templateDeviceMatch
        }
        const propertiesIncluded = () => {
            if(customerProduct.propertiesExclude) return !propertiesMatch
            return propertiesMatch
        }
/*          if(device?._id == "ea12f611-cc21-4b72-bb72-8ed4b681101f" && customerProduct?._id=="5e79ff40-d692-41a9-abb8-ebfde56744ee")console.log(
            "DEVICE", data,
            "CUSTOMER PRODUCT", customerProduct, 
            "DEVICES", devices, 
           "DEVICE PROPERTIES", deviceProperties,
           "DEVICE INCLUDED", devicesIncluded(),
           "PROPERTIES INCLUDED", propertiesMatch,
           
        ) */ 

        if ((!devices || devices?.length<=0) && (!deviceProperties || deviceProperties?.length<=0)) return true
        if (propertiesIncluded() && devicesIncluded()) return true
        if (devicesIncluded() && (!deviceProperties || deviceProperties?.length<=0) ) return true
        if ((!devices || devices?.length<=0) && propertiesIncluded()) return true
       
        return false 
    })
    return matchingCustomersProducts.map?.((item)=>({
        ...item,
        device,
        deviceNonConformity
    }))
}

/**
 * Matches customer products with the device template and properties
 * @param {Object} data {customersProducts, registerTemplate, device}
 * @returns {Array} an array of customer products that match the device template and properties
 */
export const matchSupplyCustomerProducts = (data) => {
    const {device, registerTemplate, deviceNonConformity, customerProducts = []} = data
    // const device = deviceNonConformity?.device
     const templateCustomerProducts = customerProducts.filter?.((x)=>{
         //if(x?.registers?.length < 1) return x
         //if(!x?.registers) return x
         return x?.registers?.some?.(y=>y?._ref == registerTemplate?._id)
     })
      
     const findSupplyCustomerProduct = templateCustomerProducts?.find?.((customerProduct) => {
        const isSupply = customerProduct?.supply
        const devices = customerProduct?.devices
        const deviceProperties = customerProduct?.deviceProperties

        const templateDeviceMatch = devices
            ?.some?.((x)=>x._ref == device?.templateDevice?._ref)
        
        const propertiesMatch = deviceProperties
            ?.some?.((nonConfProperty)=> device?.fields
                ?.some?.((field)=> field?.values
                    ?.some?.((value)=>value?._id == nonConfProperty?._ref))) 

        const devicesIncluded = () =>{
            if(!devices || devices?.length==0) return true
            if(customerProduct.devicesExclude) return !templateDeviceMatch
            return templateDeviceMatch
        }
        const propertiesIncluded = () => {
            if(!deviceProperties || deviceProperties?.length==0) return true
            if(customerProduct.propertiesExclude) return !propertiesMatch
            return propertiesMatch
        } 

        if (propertiesIncluded() && devicesIncluded() && isSupply) return customerProduct
        //if (!(propertiesIncluded() && devicesIncluded()) && (propertiesIncluded() || devicesIncluded()) && isSupply) return customerProduct
    })
 
     const getSupplyExtraProducts = !Array.isArray(findSupplyCustomerProduct?.supplyCustomerProducts) ? [] : findSupplyCustomerProduct?.supplyCustomerProducts?.map?.((x)=>{
        const findCP = customerProducts?.find?.((y)=>y._id == x._ref) 
        return {
             ...findCP,
             device,
             deviceNonConformity
         }
     })

     if(!findSupplyCustomerProduct) return []
     return [findSupplyCustomerProduct, ...getSupplyExtraProducts].map?.((item)=>({
         ...item,
         device,
         deviceNonConformity
     }))
}

/**
 * Finds customer products that match the device template and properties
 * @param {Object} data - object containing data for the function
 * @param {Object} data.device - device object from the device register
 * @param {Object} data.registerTemplate - register template object from the device register
 * @param {Object} data.deviceNonConformity - device non-conformity object from the inspection report
 * @param {Array} data.customerProducts - array of customer products from the customer product list
 * @returns {Array} array of customer products that match the device template and properties
 */
export const matchSubstitutionCustomerProducts = (data) => {
    const {device, registerTemplate, deviceNonConformity, customerProducts = []} = data
    // const device = deviceNonConformity?.device
     const templateCustomerProducts = customerProducts.filter?.((x)=>{
         //if(x?.registers?.length < 1) return x
         //if(!x?.registers) return x
         return x?.registers?.some?.(y=>y?._ref == registerTemplate?._id)
     })
      
     const findSupplyCustomerProduct = templateCustomerProducts?.find?.((customerProduct) => {
        const isSupply = customerProduct?.supply
        const devices = customerProduct?.devices
        const deviceProperties = customerProduct?.deviceProperties

        const templateDeviceMatch = devices
            ?.some?.((x)=>x._ref == device?.templateDevice?._ref)
        
        const propertiesMatch = deviceProperties
            ?.some?.((nonConfProperty)=> device?.fields
                ?.some?.((field)=> field?.values
                    ?.some?.((value)=>value?._id == nonConfProperty?._ref))) 

        const devicesIncluded = () =>{
            if(!devices || devices?.length==0) return true
            if(customerProduct.devicesExclude) return !templateDeviceMatch
            return templateDeviceMatch
        }
        const propertiesIncluded = () => {
            if(!deviceProperties || deviceProperties?.length==0) return true
            if(customerProduct.propertiesExclude) return !propertiesMatch
            return propertiesMatch
        } 

        if (propertiesIncluded() && devicesIncluded() && isSupply) return customerProduct
        //if (!(propertiesIncluded() && devicesIncluded()) && (propertiesIncluded() || devicesIncluded()) && isSupply) return customerProduct
    })
 
    const getSubstitutionExtraProducts = !Array.isArray(findSupplyCustomerProduct?.substitutionCustomerProducts) ? [] : findSupplyCustomerProduct?.substitutionCustomerProducts?.map?.((x)=>{
        const findCP = customerProducts?.find?.((y)=>y._id == x._ref) 
        return {
             ...findCP,
             device,
             deviceNonConformity
         }
     })

     if(!findSupplyCustomerProduct) return []
     return [findSupplyCustomerProduct, ...getSubstitutionExtraProducts].map?.((item)=>({
         ...item,
         device,
         deviceNonConformity
     }))
}